import { configureStore } from '@reduxjs/toolkit';
import reduxConstants from './reduxConstants';
import configReducer from './stateSlice';

export default configureStore({
  reducer: {
    [reduxConstants.STORE_NAME]: configReducer,
  },
});
